import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Alert, Form, InputNumber } from 'antd';
import FormField from 'components/FormField';
import { useScoreDictionary } from 'components/ReceptionScore/dictionary';
import { useTranslate } from '@tolgee/react';

export default function ReceptionScoreDelay({ disabled }: { disabled?: boolean }) {
  const { dictionary, failed } = useScoreDictionary();
  const { t } = useTranslate();
  const { validateForm } = useFormikContext();
  useEffect(() => { if (dictionary) void validateForm(); }, [dictionary, validateForm]);
  return (
    <>
      <Form.Item label={t('receptionScore.autoDelay', '自动邀评时间')}>
        <p style={{ margin: 0 }}>
          {t(
            'receptionScore.autoRule',
            '买家消息被有效回复后，持续无新消息达到设定时间，系统自动邀评；手动发送成功会取消本轮自动任务。',
          )}
        </p>
        {failed && (
          <Alert
            type="error"
            message={t('receptionScore.dictionaryFailed', '评分配置加载失败，请刷新页面')}
          />
        )}
      </Form.Item>
      {(['preSaleDelayMin', 'afterSaleDelayMin'] as const).map((key, index) => (
        <FormField<number | null>
          key={key}
          name={`scenarioConfig.receptionScoreTaskConfig.${key}`}
          label={index === 0 ? t('aide.售前买家') : t('aide.售后买家')}
          validate={(value) =>
            !dictionary ||
            value == null ||
            !Number.isInteger(value) ||
            value < 1 ||
            value > dictionary.maxDelayMin
              ? t('receptionScore.invalidDelay', '请填写有效的自动邀评分钟数')
              : undefined
          }
        >
          {({ field: { value, onChange } }) => (
            <InputNumber
              min={1}
              max={dictionary?.maxDelayMin}
              precision={0}
              value={value}
              onChange={onChange}
              disabled={disabled || !dictionary}
              addonAfter={t('receptionScore.minutes', '分钟')}
            />
          )}
        </FormField>
      ))}
    </>
  );
}
